import { ticketClient } from "@/api/ticketClient";
import { GetTicketEntrustParamReq } from "@/pbjs/external/ticket/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData, timeFormat, whetherSetParam } from "@/utils";
// lin 获取工单分配支持的所有的参数数据
interface ITicketAssignParamReq {}
export function getTicketEntrustParam() {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketEntrustParamReq();
      request.setCommonin(setCommon());
      ticketClient.getTicketEntrustParam(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
